import React from 'react';

// Official Lempole sloth mascot artwork (PNG with transparency)
const SLOTH_URL = 'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/2hq5tlkb_lempole-sloth.png';

export default function SlothLogo({ size = 44, className = '', style = {} }) {
  return (
    <img
      src={SLOTH_URL}
      alt="Lempole sloth"
      width={size}
      height={size}
      loading="eager"
      className={className}
      style={{ display: 'inline-block', objectFit: 'contain', ...style }}
    />
  );
}

// Cream wordmark (LEMPOLE) — intrinsic ratio 1000×253 (from the source PNG).
export const WORDMARK_URL = 'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/1ch6tx7s_wordmark_cream.png';
const WORDMARK_INTRINSIC_RATIO = 1000 / 253; // width / height

export function Wordmark({ height = 26, className = '', style = {} }) {
  const width = Math.round(height * WORDMARK_INTRINSIC_RATIO);
  return (
    <img
      src={WORDMARK_URL}
      alt="Lempole"
      width={width}
      height={height}
      loading="eager"
      decoding="async"
      className={className}
      style={{ display: 'inline-block', height, width: 'auto', objectFit: 'contain', ...style }}
    />
  );
}
